













































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateModal from "./create.vue";
import EditModal from "./edit.vue";
import CopyModal from './copy.vue';
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageCityRequest extends PageRequest {
    keyword: string;
    parentId: number;
}

@Component({
    components: { CreateModal, EditModal, CopyModal },
})
export default class Channel extends AbpBase {
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    /**编辑 */
    edit() {
        this.editModalShow = true;
    }
    /**复制 */
    copy() {
        this.copyModalShow = true;
    }

    pagerequest: PageCityRequest = new PageCityRequest();
    creationTime: Date[] = [];
    /**新建 */
    createModalShow: boolean = false;
    /**修改 */
    editModalShow: boolean = false;
    /**复制 */
    copyModalShow: boolean = false;
    /**左侧树开结构 */
    treedata: any[] = [];
    itemId: string = "0";
    splitnum: number = 0.15;
    get list() {
        return this.$store.state.channel.list;
    }
    get loading() {
        return this.$store.state.channel.loading;
    }
    /**左边树形结构 */
    async itemtree() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        let infolist = detaillist.filter((p) => {
            return p.itemId == 29;
        });
        this.treedata = [];
        this.treedata.push({ id: 0, title: '系统类型', children: [], expand: true });
        infolist.forEach((element) => {
            this.treedata[0].children.push({ id: element.id, title: element.name });
        });
    }
    create() {
        this.createModalShow = true;
    }
    pageChange(page: number) {
        this.$store.commit("channel/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("channel/setPageSize", pagesize);
        this.getpage();
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.parentId = item[0].id;
        }
        this.$store.commit("channel/setCurrentPage", 1);
        this.getpage();
    }
    getSearch() {
        this.$store.commit("channel/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "channel/getAll",
            data: this.pagerequest,
        });
    }
    get pageSize() {
        return this.$store.state.channel.pageSize;
    }
    get totalCount() {
        return this.$store.state.channel.totalCount;
    }
    get currentPage() {
        return this.$store.state.channel.currentPage;
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            title: this.L("IndexNo"),
        },
        {
            title: this.L("Name"),
            key: "name",
            width: 180,
            tree: true,
        },
        {
            title: this.L("SystemDetail"),
            key: "systemName",
            width: 130,
        },
        {
            title: this.L("Color"),
            key: "color",
            width: 130,
        },
        {
            title: this.L("ImageUrl"),
            key: "imageUrl",
            width: 180,
        },
        {
            title: this.L("LanguageTag"),
            key: "languageTag",
            width: 130,
        },
        {
            title: this.L("IsEnable"),
            width: 130,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.isEnable == 1 ? this.L("Actived") : this.L("NoActive")
                );
            },
        },
        {
            title: this.L("Description"),
            key: "description",
            width: 130,
        },
        {
            title: this.L("Id"),
            key: "id",
            width: 130,
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 180,
            render: (h: any, params: any) => {
                let del = this.checkButtonAuth('channelEdit');
                let edit = this.checkButtonAuth('channelDel');
                let copy = this.checkButtonAuth('channelCopy');
                return h("div", [
                    del ? h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: () => {
                                    this.$store.commit("channel/edit", params.row);
                                    this.edit();
                                },
                            },
                        },
                        this.L("Edit")
                    ) : '',
                    edit ? h(
                        "Button",
                        {
                            props: {
                                type: "success",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: async () => {
                                    this.$store.commit("channel/edit", params.row);
                                    this.copy();
                                },
                            },
                        },
                        this.L("Copy")
                    ) : '',
                    copy ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            await this.$store.dispatch({
                                                type: "channel/delete",
                                                data: params.row,
                                            });
                                            await this.getpage();
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        this.getpage();
        this.itemtree();
    }
}
